import { Card, Modal, Button, Spinner, TableHeader, TableColumn, TableBody, TableRow, TableCell, Table, ModalHeader, ModalContent, ModalBody, ModalFooter } from '@nextui-org/react';
import RootAdmin from "../../../../components/layouts/RootAdmin";
import { useState, useEffect } from 'react';
import ReactMapGL, { Marker } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { getFetcher } from '../../../../services/api';
import { HomeIcon } from "@heroicons/react/24/outline";
import toast from 'react-hot-toast';

const MapsPenyimpanan = () => {
  const [viewport, setViewport] = useState({
    latitude: -1.3911261987874894, // Center of Indonesia
    longitude: 113.4216565328876, // Longitude around Indonesia's central region
    zoom: 4, // Zoom level to focus on Indonesia
  });

  const [mapPoints, setMapPoints] = useState([]);
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true); // State for loading spinner

  const handleViewportChange = (newViewport) => {
    setViewport(newViewport);
  };

  useEffect(() => {
    // Fetch data for map points
    const fetchPoints = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await getFetcher('/api/dashboard/pelaporan/penyimpanan/geojson');
        const data = response?.features?.map((feature) => ({
          id: feature.properties.storage_id,
          company_name: feature.properties.company_id, // Replace this with actual company name from backend
          latitude: feature.geometry.coordinates[1],
          longitude: feature.geometry.coordinates[0],
          province_id: feature.properties.province_id,
          regency_id: feature.properties.regency_id,
        }));
        setMapPoints(data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch map points");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };
    fetchPoints();
  }, []);

  const fetchStorageDetails = async (storageId) => {
    try {
      const response = await getFetcher(`/api/dashboard/pelaporan/penyimpanan/penyimpanan-details/${storageId}`);
      setModalData(response.responseData);
    } catch (error) {
      toast.error("Failed to fetch storage details");
    }
  };

  const handleMarkerClick = (point) => {
    setSelectedPoint(point);
    fetchStorageDetails(point.id); // Fetch details for the clicked storage point
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPoint(null);
    setModalData(null);
  };

  return (
    <RootAdmin>
      <Card radius="sm" className="col-span-4 p-3">
        <div className="w-full h-[600px] z-10 relative">
          {/* Show Spinner while loading */}
          {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-white/75 z-10">
              <Spinner size="lg" color="primary" />
            </div>
          )}

          <ReactMapGL
            {...viewport}
            mapboxAccessToken="pk.eyJ1Ijoic2liMy1rbGhrIiwiYSI6ImNtMms1ZWVrZjAxb3MybHEyajE5cG5zb28ifQ.aCs5cuGJhZqytwo7zlVl5w"
            mapStyle="mapbox://styles/sib3-klhk/cm3i4eidd00dn01s9809ze69i"
            onMove={(evt) => handleViewportChange(evt.viewState)}
            dragPan={true}
            scrollZoom={true}
            doubleClickZoom={true}
            touchZoom={true}
          >
            {mapPoints?.map((point) => (
              <Marker key={point.id} latitude={point.latitude} longitude={point.longitude}>
                <div
                  onClick={() => handleMarkerClick(point)}
                  style={{ cursor: 'pointer', fontSize: '24px', color: 'blue' }}
                >
                  📍
                </div>
              </Marker>
            ))}
          </ReactMapGL>
        </div>
      </Card>

      {/* Modal for Point Details */}

      <Modal
        size="lg"
        isOpen={isModalOpen}
        onClose={closeModal}
        className={'bg-line'}
      > 
        <ModalContent>
            {(onClose) => (
                <>
                    <ModalHeader className="flex flex-col gap-1">
                        Detail Penyimpanan
                    </ModalHeader>
                    <ModalBody className={'flex flex-col gap-1'}>
                    {modalData ? (
                    <div>
                        <p>
                            <strong>Nama Perusahaan:</strong> {modalData?.company?.name}
                        </p>
                        <p>
                            <strong>Alamat Gudang:</strong> {modalData?.alamatGudang}
                        </p>
                        <p>
                            <strong>Provinsi:</strong> {modalData?.province?.name}
                        </p>
                        <p>
                            <strong>Kabupaten/Kota:</strong> {modalData?.regency?.name}
                        </p>
                        <p>
                              <strong>Luas Area:</strong> {modalData.luasArea} m<sup>2</sup>
                        </p>
                        <p>
                            <strong>Coordinates:</strong> {modalData.latitude}, {modalData.longitude}
                        </p>
                        <div className="flex w-full justify-center">
                            <Table aria-label="Example static collection table">
                                <TableHeader>
                                    <TableColumn>Nama Bahan Kimia</TableColumn>
                                    <TableColumn>Cas Number</TableColumn>
                                    <TableColumn>Stok B3</TableColumn>
                                </TableHeader>
                                <TableBody>
                                    {modalData?.company?.DataBahanB3Company?.length >= 1 ? modalData?.company?.DataBahanB3Company?.map((b3, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{b3.namaBahanKimia}</TableCell>
                                            <TableCell>{b3.casNumber}</TableCell>
                                            <TableCell>{b3.stokB3 ?? 0}</TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow key={0}>
                                            <TableCell colSpan={3} style={{ textAlign: "center" }}>
                                                No Data
                                            </TableCell>
                                            <TableCell className={'hidden'}/>
                                            <TableCell className={'hidden'}/>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                  ) : (
                    <div className="absolute inset-0 flex items-center justify-center bg-white/75 z-10">
                      <Spinner size="lg" color="primary" />
                    </div>
                  )}
                       
                    </ModalBody>
                    <ModalFooter/>
                </>
            )}
        </ModalContent>
    </Modal>
    </RootAdmin>
  );
};

export default MapsPenyimpanan;
